// Tracks the best score ever achieved per daily-test pack, so the level
// select list can show star ratings like a game level map. Mirrors the
// mobile app's ExerciseScoreService (localStorage instead of SharedPreferences).
const key = (langCode, packId) => `exercise_best_${langCode}_${packId}`;

export const ExerciseScoreService = {
  bestPercentsFor(langCode, packIds) {
    const result = {};
    for (const id of packIds) {
      const raw = localStorage.getItem(key(langCode, id));
      result[id] = raw !== null ? parseInt(raw, 10) : -1;
    }
    return result;
  },

  recordResult(langCode, packId, scorePercent) {
    const k = key(langCode, packId);
    const existing = parseInt(localStorage.getItem(k) ?? '-1', 10);
    if (scorePercent > existing) localStorage.setItem(k, String(scorePercent));
  },

  starsForPercent(percent) {
    if (percent >= 90) return 3;
    if (percent >= 60) return 2;
    if (percent >= 0) return 1;
    return 0;
  },
};
